import { message, WidgetUtilsContext } from '@homemaster/jslib'
import BarChartIcon from '@mui/icons-material/BarChart'
import BusinessIcon from '@mui/icons-material/Business'
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import SchoolIcon from '@mui/icons-material/School'
import SettingsRemoteIcon from '@mui/icons-material/SettingsRemote'
import StorefrontIcon from '@mui/icons-material/Storefront'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { zhCN as muiZhCN } from '@mui/x-date-pickers/locales'
import { LicenseInfo } from '@mui/x-license'
import { zhCN } from 'date-fns/locale'
import { useEffect } from 'react'
import { createBrowserRouter, Navigate } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import MainWindow, { type NavItem } from './MainWindow'
import CouponTemplatesPage from './pages/CouponTemplatesPage'
import CourseEntitlementsPage from './pages/CourseEntitlementsPage'
import CoursesPage from './pages/CoursesPage'
import CustomerPaymentsPage from './pages/CustomerPaymentsPage'
import DashboardPage from './pages/DashboardPage'
import EventsPage from './pages/EventsPage'
import InvoiceRequestsPage from './pages/InvoiceRequestsPage'
import IotControlPointsPage from './pages/IotControlPointsPage'
import OrdersPage from './pages/OrdersPage'
import SessionStatsPage from './pages/SessionStatsPage'
import SessionsPage from './pages/SessionsPage'
import EditSitePage from './pages/SitesPage/EditSitePage'
import SlotsPage from './pages/SlotsPage'
import SlotTemplatePage from './pages/SlotTemplatePage'
import StaffPage from './pages/StaffPage'
import UserCouponsPage from './pages/UserCouponsPage'
import widgetUtils from './widgetUtils'

// register MUI-X license key, expires on Jan. 25, 2027
LicenseInfo.setLicenseKey(
  '64a59fe7cef759ee6dc51c9b876f1d97Tz0xMjM3MzgsRT0xODAwOTIxNTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MSxBVD1tdWx0aSxLVj0y',
)

export const navItems: NavItem[] = [
  {
    group: '数据统计',
    icon: <BarChartIcon />,
    children: [
      { text: '数据看板', path: '/dashboard' },
      { text: '客户收支', path: '/customer-payments' },
    ],
  },
  {
    group: '场馆管理',
    icon: <StorefrontIcon />,
    children: [
      { text: '场地管理', path: '/slots' },
      { text: '订单管理', path: '/orders' },
      { text: '活动管理', path: '/events' },
    ],
  },
  {
    group: '教学管理',
    icon: <SchoolIcon />,
    children: [
      { text: '课程管理', path: '/courses' },
      { text: '已售课时', path: '/course-entitlements' },
      { text: '课程预约', path: '/sessions' },
      { text: '课程统计', path: '/session-stats' },
    ],
  },
  {
    group: '优惠券',
    icon: <CardGiftcardIcon />,
    superAdminOnly: true,
    children: [
      { text: '模板管理', path: '/coupon-templates' },
      { text: '用户优惠券', path: '/user-coupons' },
    ],
  },
  { text: '发票管理', icon: <ReceiptLongIcon />, path: '/invoices' },
  {
    group: '场馆设置',
    icon: <BusinessIcon />,
    children: [
      { text: '时段模板', path: '/slot-templates' },
      { text: '人员设置', path: '/staff', superAdminOnly: true },
      { text: '场馆信息', path: '/site/edit' },
    ],
  },
  {
    group: '设备控制',
    icon: <SettingsRemoteIcon />,
    featureGate: 'iot',
    children: [{ text: '设备控制', path: '/iot' }],
  },
]

/** Site app main window */
function SiteMainWindow() {
  return <MainWindow navItems={navItems} />
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <SiteMainWindow />,
    children: [
      { index: true, element: <Navigate to="/slots" replace /> },
      { path: 'dashboard', element: <DashboardPage /> },
      { path: 'customer-payments', element: <CustomerPaymentsPage /> },
      { path: 'slots', element: <SlotsPage /> },
      { path: 'orders', element: <OrdersPage /> },
      { path: 'events', element: <EventsPage /> },
      { path: 'invoices', element: <InvoiceRequestsPage /> },
      { path: 'courses', element: <CoursesPage /> },
      { path: 'course-entitlements', element: <CourseEntitlementsPage /> },
      { path: 'sessions', element: <SessionsPage /> },
      { path: 'session-stats', element: <SessionStatsPage /> },
      { path: 'slot-templates', element: <SlotTemplatePage /> },
      { path: 'staff', element: <StaffPage /> },
      { path: 'coupon-templates', element: <CouponTemplatesPage /> },
      { path: 'user-coupons', element: <UserCouponsPage /> },
      { path: 'iot', element: <IotControlPointsPage /> },
      { path: 'site/edit', element: <EditSitePage /> },
    ],
  },
])

function AppMain() {
  useEffect(() => {
    message.init()
  }, [])

  return (
    <WidgetUtilsContext value={widgetUtils}>
      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={zhCN}
        localeText={muiZhCN.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <RouterProvider router={router} />
      </LocalizationProvider>
    </WidgetUtilsContext>
  )
}

export default AppMain
